import { QmsField } from "@callveriq/modules/settings/modules/qmsManager/context/QmsStateContext";
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { BulkUploadData } from "@callveriq/type/Report";

export const qmsApiSlice = createApi({
    reducerPath: "QmsApiSlice",
    baseQuery: axiosBaseQuery({
        transformResponse: (response) => response,
    }),
    endpoints: (builder) => ({
        getManualQmsFieldsList: builder.query<QmsField[], void>({
            query: () => "audit/qms/list_all/",
        }),
        createQmsField: builder.mutation<QmsField, QmsField>({
            query: ({ ...payload }) => ({
                url: "audit/qms/",
                method: "POST",
                body: payload,
            }),
            async onQueryStarted(_, { queryFulfilled, dispatch }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(
                        qmsApiSlice.util.updateQueryData(
                            "getManualQmsFieldsList",
                            undefined,
                            (draft) => {
                                Object.assign(draft, [...draft, data]);
                            }
                        )
                    );
                } catch {
                    return;
                }
            },
        }),
        updateQmsFiled: builder.mutation<QmsField, QmsField>({
            query: ({ ...payload }) => ({
                url: `audit/qms/${payload.id}/`,
                method: "PATCH",
                body: payload,
            }),
            async onQueryStarted(
                { id, is_disabled, is_mandatory },
                { queryFulfilled, dispatch }
            ) {
                const patchResult = dispatch(
                    qmsApiSlice.util.updateQueryData(
                        "getManualQmsFieldsList",
                        undefined,
                        (draft) => {
                            Object.assign(
                                draft,
                                draft.map((e) =>
                                    e.id === id
                                        ? { ...e, is_disabled, is_mandatory }
                                        : e
                                )
                            );
                        }
                    )
                );
                try {
                    const { data } = await queryFulfilled;
                    dispatch(
                        qmsApiSlice.util.updateQueryData(
                            "getManualQmsFieldsList",
                            undefined,
                            (draft) => {
                                Object.assign(
                                    draft,
                                    draft.map((e) =>
                                        e.id === data.id ? data : e
                                    )
                                );
                            }
                        )
                    );
                } catch {
                    patchResult.undo();
                }
            },
        }),
        updateQmsUpload: builder.mutation<
            BulkUploadData<"MANUAL_QMS">,
            Pick<BulkUploadData<"MANUAL_QMS">, "id" | "mapping">
        >({
            query: ({ id, mapping }) => ({
                url: `/feedback/bulk_upload/${id}/`,
                method: "PATCH",
                body: { mapping },
            }),
        }),
    }),
});

export const {
    useGetManualQmsFieldsListQuery,
    useUpdateQmsFiledMutation,
    useCreateQmsFieldMutation,
    useUpdateQmsUploadMutation,
} = qmsApiSlice;
